module.exports = __webpack_public_path__ + "static/media/logo.a707b4db.png";